/* RESPONSIBLE TEAM: team-reporting */
import Controller from '@ember/controller';

export default class ManageController extends Controller {
  queryParams = [];
}
